import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./ReasonListModal.scss";

import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import SearchInput from "../SearchInput/SearchInput";
import useDebounce from "../../hooks/useDebounce";
import fakeId from "../../utils/fakeId";

function getSelected(items, selectedDict) {
  return items.filter(i => selectedDict[i.id]);
}

function getFavorite(items) {
  return items.filter(i => i.favorite);
}

function getFiltered(items, search) {
  return items.filter(
    i => i.message.toLowerCase().indexOf(search.toLowerCase()) != -1
  );
}

const ReasonListModal = ({
  items,
  selected,
  onConfirm,
  onCancel,
  showPrice
}) => {
  const [selectedItems, setSelected] = useState(selected);
  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search, 500);

  const favoriteItems = useMemo(() => getFavorite(items), []);
  const filteredItems = useMemo(() => getFiltered(items, debounceSearch), [
    debounceSearch
  ]);

  const title = useMemo(() => {
    if (showPrice) {
      const price = selectedItems.reduce((prev, current) => {
        return prev + parseInt(current.price) || 0;
      }, 0);

      return `Выбрать причину (${price} ₽)`;
    }

    const cnt = selectedItems.length;

    return `Выбрать причину (${cnt})`;
  }, [selectedItems]);

  const onConfirmClick = () => {
    onConfirm({ selectedItems });
  };

  const addReason = reason => {
    let message = reason.message;
    if (reason.number) {
      message = reason.number + " " + message;
    }

    const r = { id: fakeId(), message, price: reason.price };
    setSelected(prev => [...prev, r]);
  };

  const removeReason = reason => {
    setSelected(prev => prev.filter(item => item.id != reason.id));
  };

  const onItemChange = (id, payload) => {
    setSelected(prev =>
      prev.map(item => {
        if (item.id == id) {
          return { ...item, ...payload };
        }
        return item;
      })
    );
  };

  const renderSelectedItems = items =>
    items.map(item => (
      <div
        className={classnames(
          "reason-list-modal__row reason-list-modal__row-colored"
        )}
      >
        <textarea
          className="reason-list-modal__left reason-list-modal__input"
          value={item.message}
          onChange={e => {
            onItemChange(item.id, { message: e.target.value });
          }}
        />

        {showPrice && (
          <div className="reason-list-modal__middle">
            <input
              type="text"
              value={item.price}
              onChange={e => onItemChange(item.id, { price: e.target.value })}
            />
          </div>
        )}
        <div
          className="reason-list-modal__right"
          onClick={() => removeReason(item)}
        >
          <i className="reason-list-modal__close-ico" />
        </div>
      </div>
    ));

  const renderItems = items =>
    items.map(item => (
      <div
        className={classnames(
          "reason-list-modal__row reason-list-modal__row-colored"
        )}
        onClick={() => {
          addReason(item);
        }}
      >
        <div className="reason-list-modal__left">
          {item.number} {item.message}
        </div>
        {showPrice && (
          <div className="reason-list-modal__middle">{item.price}</div>
        )}
        <div className="reason-list-modal__right" />
      </div>
    ));

  return (
    <Modal className="reason-list-modal" onClose={onCancel}>
      <div className="modal__header">
        <div className="modal__title">{title}</div>
        <div className="modal__controls">
          <SearchInput
            onChange={e => setSearch(e.target.value)}
            value={search}
          />
          <Button color="gray" onClick={onCancel}>
            Отмена
          </Button>
          <Button color="blue" onClick={onConfirmClick}>
            Сохранить
          </Button>
        </div>
      </div>

      <div className="modal__body">
        <div className="reason-list-modal__items">
          {/* выбранные */}
          <div className="reason-list-modal__row reason-list-modal__row-header">
            <div className="reason-list-modal__left">Выбранные варианты:</div>
            {showPrice && (
              <div className="reason-list-modal__middle">Сумма:</div>
            )}
            <div className="reason-list-modal__right">Выбрано</div>
          </div>
          {renderSelectedItems(selectedItems)}

          {/*Популярные*/}
          <div className="reason-list-modal__row reason-list-modal__row-header">
            <div className="reason-list-modal__left">Популярные варианты:</div>
          </div>
          {renderItems(favoriteItems)}

          {/*все*/}
          <div className="reason-list-modal__row reason-list-modal__row-header">
            <div className="reason-list-modal__left">Все варианты:</div>
          </div>
          {renderItems(filteredItems)}
        </div>
      </div>
    </Modal>
  );
};

ReasonListModal.defaultProps = {
  items: [],
  selected: []
};

ReasonListModal.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ReasonListModal;
